function number (value, decimals) {
  if (typeof (value) !== 'number') return value
  return value.toFixed(decimals)
}

export default number
